const SignatureBox = () => {
    return (
        <iframe
            src="/gerador.html"
            style={{ width: "100%", height: "100vh", border: "none" }}
            title="Gerador de Assinaturas"
        />
    );
};

export default SignatureBox;